import {
  AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, Output, PLATFORM_ID, ViewChild
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { UiContextService } from '@cakeiteasy/web-utils';

// CSS variable with the height of the bar while it is stuck to the top of the window (0 otherwise), so sticky page
// blocks can stay below it (see ws-grid-cell-top in styles/themable/theme)
const STICKY_HEIGHT_VAR = '--cart-bar-sticky-height';

@Component({
  standalone: false,
  selector: 'cart-show-and-checkout',
  templateUrl: './cart-show-and-checkout.component.html',
  styleUrls: ['./cart-show-and-checkout.component.scss']
})
export class CartShowAndCheckoutComponent implements AfterViewInit, OnDestroy {
  @Input() extraOffset = 60;
  @Output() onContinue = new EventEmitter<void>();
  @Output() onStick = new EventEmitter<boolean>();

  @ViewChild('bar', { static: true }) bar: ElementRef<HTMLElement>;

  public isStick: boolean;

  private _resizeObserver: ResizeObserver;
  private _stickyHeight: number;

  constructor(public ui: UiContextService,
              @Inject(DOCUMENT) private _document: Document,
              @Inject(PLATFORM_ID) private _platformId: object) {
  }

  ngAfterViewInit() {
    if (!isPlatformBrowser(this._platformId) || typeof ResizeObserver === 'undefined') {
      return;
    }

    // the bar's content renders only while it is stuck, and it is hidden below md, so its size tells both
    this._resizeObserver = new ResizeObserver(() => this._updateStickyHeight());
    this._resizeObserver.observe(this.bar.nativeElement);
  }

  ngOnDestroy() {
    this._resizeObserver?.disconnect();
    this._document.documentElement.style.removeProperty(STICKY_HEIGHT_VAR);
  }

  setStick(isStick: boolean) {
    this.isStick = isStick;
    this.onStick.emit(isStick);
    this._updateStickyHeight();
  }

  private _updateStickyHeight() {
    const height = this.isStick && this.bar ? this.bar.nativeElement.offsetHeight : 0;

    if (height === this._stickyHeight || !isPlatformBrowser(this._platformId)) {
      return;
    }

    this._stickyHeight = height;
    this._document.documentElement.style.setProperty(STICKY_HEIGHT_VAR, `${height}px`);
  }
}
